/**
 * 缓存说明:台账设备缓存
 */
import vm from './storeTools.js'
import archivesApi from '../components/api/archivesApi.js'
//import deviceApi from '../components/api/deviceApi.js'
import entityApi from '../components/api/entityApi.js'
var archivesStoreWaitToGetInfoArchivesIds = []
var basestate = {
	archivesTree: undefined,
	archivesIdToInfo: {},
	entityTypeList: [],
	archivesGroupTree: undefined,
	valueEnum: [{
		value: 0,
		text: '文本'
	}, {
		value: 1,
		text: '长文本'
	}, {
		value: 2,
		text: '整型'
	}, {
		value: 3,
		text: '浮点型'
	}, {
		value: 4,
		text: '日期'
	}, {
		value: 5,
		text: '日期时间'
	}, {
		value: 6,
		text: '布尔型'
	}/* , {
		value: 7,
		text: '枚举'
	}, {
		value: 8,
		text: '图片'
	}, {
		value: 9,
		text: '控件'
	} */],
	deviceNoToArchives: {
		//虚拟设备no对应台账设备信息
	},
	archivesIdToBindInfo: {
		//台账设备ID对应关联的虚拟设备或者组信息
	},
	entityTypeTreeList:undefined,//台账树缓存
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getValueEnum(state, getters) {
			return copy(state.valueEnum)
		},
		getReadDeviceGroupTree(state, getters) {
			if (state.archivesGroupTree == undefined) {
				store.commit("getReadDeviceGroupTree")
				return []
			}
			return state.archivesGroupTree
		},
		getArchivesTreeByUnitId(state, getters) {
			return unitId => {
				if (state.archivesTree == undefined) {
					store.commit("getArchivesTree")
					return {}
				}
				if (unitId == undefined) {
					return state.archivesTree
				}
				var tree = findTreeItem([state.archivesTree], item => {
					return item.unitid == unitId
				})
				if (tree == undefined) {
					return {}
				}
				return tree
			}
		},
		getArchivesTree(state, getters) {
			return getters.getArchivesTreeByUnitId()
		},
		getArchivesInfoById(state, getters) {
			return id => {
				//获取台账的属性值列表
				if (state.archivesIdToInfo[id] == undefined) {
					archivesStoreWaitToGetInfoArchivesIds.push(id)
					return []
				}
				return state.archivesIdToInfo[id]
			}
		},
		getEntityTypeSingleList(state, getters) {
			if (getters.getArchivesTypeList.length == 0) {
				return []
			}
			var list = treeToList({
				next: getters.getArchivesTypeList
			}, 'next', item => item.hasOwnProperty('next'))
			return list
		},
		getEntityTypeList(state, getters) {
			return typeEnum => {
				if (isempty(state.entityTypeList)) {
					store.commit("getEntityTypeList")
					return []
				}
				return state.entityTypeList.filter(item => {
					return item.typeEnum == typeEnum
				})
			}
		},
		getArchivesTypeList(state, getters) {
			if (isempty(state.entityTypeList)) {
				store.commit("getEntityTypeList")
				return []
			}
			return state.entityTypeList
		},
		/**
		 * 过滤掉属性值后的列表
		 */
		getEntityTypeTreeList(state, getters) {
			function removeTypeProperty(list) {
				var nl = []
				for (var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					if (item.entityName == 'MisEntityType') {
						item.next = removeTypeProperty(item.next)
						nl.push(item)
					}
				}
				return nl
			}
			return removeTypeProperty(copy(getters.getArchivesTypeList))
		},
		getValueTypeText(state, getters) {
			return value => {
				switch (value) {
					case 0:
						return '文本'
					case 1:
						return '长文本'
					case 2:
						return '整型'
					case 3:
						return '浮点型'
					case 4:
						return '日期'
					case 5:
						return '日期时间'
					case 6:
						return '布尔型'
					/* case 7:
						return '枚举'
					case 8:
						return '图片'
					case 9:
						return '控件' */
					default:
						return '无效类型'
				}
			}
		},
		getAlignText(state, getters) {
			return value => {
				switch (value) {
					case 0:
						return '左边'
					case 1:
						return '右边'
					case 2:
						return '居中'
					default:
						return '无效类型'
				}
			}
		},
		getArchivesByDeviceNos(state) {
			//批量通过虚拟设备no数组获取台账设备信息
			return deviceNos => {
				var list = []
				var needSearchList = []

				for (var i = 0, len = deviceNos.length; i < len; i++) {
					var item = state.deviceNoToArchives[deviceNos[i]]
					if (item == undefined) {
						needSearchList.push(deviceNos[i])
						list.push(undefined)
						continue
					}
					list.push(item)
				}
				if (!isempty(needSearchList)) {
					store.commit('getArchivesByDeviceNos', needSearchList.join(','))
				}
				return list
			}
		},
		getPropertyByTypeCode(state, getters) {
			//获取指定类型的台账的所有属性值
			return typeCode => {
				//递归，找到这个类型，然后所有的上级属性也要继承下来
				var getList = (entityTypeList, typeCode) => {
					for (var i = 0, len = entityTypeList.length; i < len; i++) {
						var entityType = entityTypeList[i]
						if (entityType.entityName == "MisEntityType") {
							if (entityType.typeCode == typeCode) {
								//找到了，返回属性列表
								return entityType.next.filter(item => item.entityName == "MisTypeProperty")
							}
							//没找到就递归下去
							var list = getList(entityType.next, typeCode)
							if (list != undefined) {
								//是下级的类型，加上本级类型
								return entityType.next.filter(item => item.entityName == "MisTypeProperty").addAll(list)
							}
						}
					}
				}
				return getList(getters.getArchivesTypeList, typeCode)
			}
		},
		getBindInfoMapByArchivesIdList(state) {
			//查询台账设备对应的绑定信息
			return list => {
				var map = {}
				var archivesIdToBindInfo = state.archivesIdToBindInfo
				var needGet = []
				for (var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					if (archivesIdToBindInfo.hasOwnProperty(item)) {
						map[item] = archivesIdToBindInfo[item]
					}else{
						needGet.push(item)
					}
				}
				if (needGet.length != 0) {
					store.commit('getBindInfoMapByArchivesIdList',needGet.join(','))
				}
				return map
			}
		}

	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getReadDeviceGroupTree(state) {
			archivesApi.getReadDeviceGroupTree(respon => {
				vm.Vue.set(state, 'archivesGroupTree', respon)
			})
		},
		getArchivesTree(state) {
			function countArchives(tree) {
				//数量是用类型编码：数量来保存的，只统计当前直属下级的设备数量
				var map = {}
				//先算当前层级下的
				for (var i = 0, len = tree.next.length; i < len; i++) {
					var item = tree.next[i]
					if (item.entityName == 'AppEquipmentArchives') {
						map[item.typeCode] = map.hasOwnProperty(item.typeCode) ? map[item.typeCode] + 1 : 1
					} else if (item.entityName == 'AppClassType') {
						//那就递归一下
						countArchives(item)
					}
				}
				//设置到当前对象中
				tree.archivesCountMap = map
			}
			archivesApi.getArchivesTree(respon => {
				//递归统计每一级有多少个设备，并且是按类型分类统计的
				countArchives(respon)
				vm.Vue.set(state, 'archivesTree', respon)
			})
		},
		getArchivesInfoById(state, ids) {
			archivesApi.getArchivesInfoByIds(ids, respon => {
				for (var i = 0, len = respon.length; i < len; i++){
					var item = respon[i]
					vm.Vue.set(state.archivesIdToInfo,item.id,item.next)
				}
			})
		},
		getEntityTypeList(state) {
			entityApi.getEntityTypeList(respon => {
				vm.Vue.set(state, 'entityTypeList', respon)
			})
		},
		getArchivesByDeviceNos(state, deviceNos) {
			archivesApi.getArchivesInfoByVirtualDeviceNos(deviceNos, respon => {
				var keys = Object.keys(respon)
				for (var i = 0, len = keys.length; i < len; i++) {
					var item = keys[i]
					vm.Vue.set(state.deviceNoToArchives, item, respon[item])
				}
			})
		},		
		getBindInfoMapByArchivesIdList(state, ids) {
			archivesApi.getVirtualInfoByArchivesIds(ids, respon => {
				var newMap = copy(state.archivesIdToBindInfo)
				eachObject(respon, (item, key) => {
					newMap[key] = item
				})
				state.archivesIdToBindInfo = newMap
			})
		},
	}
});

//定时获取
addNewTask('getArchivesInfoByArchivesIdList', 0, 1000, -1, () => {
	if (archivesStoreWaitToGetInfoArchivesIds.length>0) {
		store.commit('getArchivesInfoById',archivesStoreWaitToGetInfoArchivesIds.join(','))
		archivesStoreWaitToGetInfoArchivesIds = []
	}
})

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
